/**
 * How a return from a tracking app's consent screen ended.
 *
 * Arrives on the query string when the service redirects the browser back, so
 * the reporting page can say what happened in its own words rather than
 * dropping someone back on a page that looks like nothing happened.
 */
export enum TrackerConnectOutcome {
  Connected = "connected",
  Declined = "declined",
  HandoffExpired = "handoff_expired",
  ScopeTooNarrow = "scope_too_narrow",
  ProviderUnavailable = "provider_unavailable",
}
